import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-defrosting-process-running',
  templateUrl: './defrosting-process-running.component.html',
  styleUrl: './defrosting-process-running.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefrostingProcessRunningComponent {}
